import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { portfolioImg } from "@/lib/api";
import { CATEGORY_LABEL, EXAMPLE_NOTE } from "@/components/supply/portfolio";

const NavBtn = ({ onClick, label, testId, children }) => (
  <button type="button" onClick={onClick} aria-label={label} data-testid={testId}
          className="h-11 w-11 inline-flex items-center justify-center border transition-colors hover:bg-black hover:text-white"
          style={{ borderColor: "var(--ss-border)" }}>{children}</button>
);

export const PortfolioLightbox = ({ items, index, setIndex }) => {
  const open = index !== null;
  const p = open ? items[index] : null;
  const go = (d) => setIndex((index + d + items.length) % items.length);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "ArrowRight") go(1); if (e.key === "ArrowLeft") go(-1); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setIndex(null); }}>
      <DialogContent className="max-w-5xl w-[95vw] p-3 md:p-5 bg-white [&>button]:hidden" data-testid="portfolio-lightbox">
        <DialogTitle className="sr-only">{p ? CATEGORY_LABEL[p.category] : "Photo"}</DialogTitle>
        {p && (
          <div>
            <div className="flex justify-end mb-2">
              <NavBtn onClick={() => setIndex(null)} label="Close" testId="portfolio-lightbox-close"><X size={18} /></NavBtn>
            </div>
            <img src={portfolioImg(p.id, "full")} alt={p.caption || CATEGORY_LABEL[p.category]}
                 className="w-full max-h-[70vh] object-contain bg-neutral-50" data-testid="portfolio-lightbox-img" />
            <div className="mt-3 flex items-center gap-3">
              {items.length > 1 && <NavBtn onClick={() => go(-1)} label="Previous photo" testId="portfolio-lightbox-prev"><ChevronLeft size={18} /></NavBtn>}
              <div className="flex-1 min-w-0 text-sm">
                <div className="font-label text-[0.65rem]" style={{ color: "var(--ss-rust)" }}>{CATEGORY_LABEL[p.category]}</div>
                {p.caption && <div className="mt-1" data-testid="portfolio-lightbox-caption">{p.caption}</div>}
                <div className="mt-1 text-xs" style={{ color: "var(--ss-muted)" }}>{EXAMPLE_NOTE}</div>
              </div>
              {items.length > 1 && <NavBtn onClick={() => go(1)} label="Next photo" testId="portfolio-lightbox-next"><ChevronRight size={18} /></NavBtn>}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
